import { YOOKASSA_CONFIG } from '../config/yookassa';

/**
 * Создает платеж в ЮKassa через backend API и делает redirect на оплату
 * Упрощенный сценарий: только redirect, без виджета
 */
export const createYooKassaPayment = async (
  amount = YOOKASSA_CONFIG.AMOUNT,
  description = YOOKASSA_CONFIG.DESCRIPTION,
  returnUrl = YOOKASSA_CONFIG.RETURN_URL,
  promoCode = null
) => {
  // Объявляем apiUrl вне try-catch, чтобы он был доступен в catch блоке
  const apiUrl = YOOKASSA_CONFIG.CREATE_PAYMENT_API;

  try {
    // Логирование для отладки
    console.log('Creating YooKassa payment, API URL:', apiUrl);

    const requestBody = {
      amount,
      description,
      return_url: returnUrl,
    };
    
    // Добавляем промокод в метаданные, если он есть
    if (promoCode) {
      requestBody.metadata = {
        promoCode: promoCode,
      };
    }

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Ошибка сервера (${response.status}): ${errorText || 'Не удалось создать платеж'}`);
    }

    const data = await response.json();

    // Валидация ответа
    if (!data || !data.paymentUrl) {
      throw new Error('Некорректный формат ответа от сервера: отсутствует paymentUrl');
    }

    // Сохраняем payment_id для проверки суммы после редиректа
    if (data.payment_id) {
      localStorage.setItem('yookassa_payment_id', data.payment_id);
    }

    // Простой редирект на страницу оплаты ЮKassa
    window.location.href = data.paymentUrl;
    return data;
  } catch (error) {
    // Перехватываем сетевые ошибки
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      console.error('Ошибка сети при создании платежа ЮKassa:', error);
      console.error('API URL был:', apiUrl);
      console.error('Полная ошибка:', error.message, error.stack);
      throw new Error(`Ошибка сети. URL: ${apiUrl}. Проверьте подключение к интернету и настройки backend.`);
    }

    console.error('Ошибка при создании платежа ЮKassa:', error);
    console.error('API URL был:', apiUrl);
    throw error;
  }
};
